import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of } from 'rxjs';
import { switchMap, map, tap } from 'rxjs/operators';
import { RouteService } from '@services/route.service';
import { GlobalService } from '@services/global.service';
import { Gamme, Filter } from '@models/product';

@Component({
  selector: 'gob-gamme-form',
  templateUrl: './gamme-form.component.html',
  styleUrls: ['./gamme-form.component.css']
})
export class GammeFormComponent implements OnInit {
  loading: boolean=false;
  error: string;
  msg: string;
  gamme: Gamme;
  filters: Filter[]=[];

  constructor(public route: RouteService, private router: ActivatedRoute, private gServ: GlobalService) {
    this.loading=true;
    this.gamme=new Gamme();
    this.router.paramMap
      .pipe(
        switchMap(params => {
          if(params.get('id')){
            return this.gServ.getGammes()
                      .pipe(
                        map(gammes => gammes.find(c => c.ident==params.get('id'))),
                        tap((gamme) => this.gamme=JSON.parse(JSON.stringify(gamme)))
                      );
          }
          else
            return of(new Gamme());
        }),
        switchMap(() => this.gServ.getFilters()),
        tap(filters => this.filters=filters)
      )
      .subscribe({
        next: () => this.loading=false,
        error: e => {
          this.error=e;
          this.loading=false;
        }
      });
  }

  ngOnInit(): void {
  }

  isActive(ident: string){
    return (this.gamme.filters.findIndex(filter => filter==ident)!=-1 || this.isDefault(ident));
  }

  isDefault(ident: string){
    return (ident=="filter-price" /* || ident=="filter-age" || ident=="filter-players" */);
  }

  setFilter(ident: string, event: any){
    if(event.target.checked)
      this.gamme.filters.push(ident);
    else
      this.gamme.filters.splice(this.gamme.filters.findIndex(filter => filter==ident), 1);
  }

  update(form: any){
    this.loading=true;
    let update: boolean=(this.gamme.ident!=null);
    this.gServ.setGamme(this.gamme).subscribe({
      next: () => {
        this.msg='Modification enregistrée';
        if(!update)
          form.reset();
        this.loading=false;
      },
      error: e => {
        this.error=e;
        this.loading=false;
      }
    });
  }

  rm(){
    if(confirm("Etes-vous sur de vouloir supprimer ?")){
      this.loading=true;
      this.gServ.rmGamme(this.gamme.ident).subscribe({
        next: () => this.route.navigate('class-list'),
        error: e => {
          this.error=e;
          this.loading=false;
        }
      });
    }
  }
}
